<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-09 15:06:48
 * @LastEditTime: 2019-09-10 21:22:33
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="logo-container">
    <img
      :src="$store.state.app[$store.state.app.theme].navlogo"
      class="logo"
    >
  </div>
</template>

<script>
import logo from '@/assets/images/login/nav-logo@2x.png'
export default {
  name: 'Logo',
  props: {
    collapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: '学智云-师训平台',
      logo: logo
    }
  },
  created() {
    // console.info(this.$store.state.app.theme)
    // console.info(this.$store.state.app[this.$store.state.app.theme])
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.logo-container {
  /*float: left;*/
  .logo {
    display: block;
    width: 106px;
    height: 26px;
    /*margin: 12px 0 0 25px;*/
  }
}
</style>
